import { BadgeProps } from "./interface";
import Icon from "../../Foundation/Icons";
import classes from "./badge.module.scss";
import classNames from "classnames/bind";
import { IconColours } from "../../Foundation/Icons/interface";

const iconColours = {
    Live: IconColours.black,
    Generic: IconColours.red500,
    Topic: IconColours.white,
    NeutralDark: IconColours.white,
};

const Badge = ({ type, text, icon, iconRight, className }: BadgeProps) => {
    if (!type || !text) return null;

    const cx = classNames.bind(classes);
    const badgeClass = cx("badge", [type, icon, className], {
        iconRight: iconRight,
    });
    const badgeTextClass = cx("badgeText");

    return (
        <div className={badgeClass} data-testid="badge">
            {icon && (
                <Icon
                    name={icon}
                    size="16"
                    colour={iconColours[type]}
                    ariaHidden={true}
                />
            )}
            <div
                className={badgeTextClass}
                data-testid="badge-name"
                data-cy="badgetext"
            >
                {text}
            </div>
        </div>
    );
};

export default Badge;
